// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2KTNW","info":"PatientInfo_info__17j7E"};